import { Plus, SquarePen } from 'lucide-react';
import { RoundTabs, type RoundTabItem } from '@/shared/components/round-tabs';

export type InviteSection = 'cadastro' | 'regras';

interface PublicInviteSectionTabsProps {
  active: InviteSection;
  onChange: (section: InviteSection) => void;
  /** `passbook.backgroundColor` — mesma cor do header, usada no ícone ativo. */
  accentColor?: string;
  /** `passbook.foregroundColor` — par de texto/ícone da própria loja pra `accentColor` (senão fica ilegível em cores claras, ex.: Café François). */
  foregroundColor?: string;
}

const INVITE_SECTION_TABS: readonly RoundTabItem<InviteSection>[] = [
  { id: 'cadastro', label: 'Cadastro', icon: SquarePen },
  { id: 'regras', label: 'Informações', icon: Plus },
];

/** Alterna entre o form e as regras de fidelidade — pedido do time pra substituir o modal por um toggle visível. */
export function PublicInviteSectionTabs({
  active,
  onChange,
  accentColor,
  foregroundColor,
}: PublicInviteSectionTabsProps) {
  return (
    <RoundTabs
      items={INVITE_SECTION_TABS}
      active={active}
      onChange={onChange}
      accentColor={accentColor}
      foregroundColor={foregroundColor}
    />
  );
}
